import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_Link;

const ClientPortalServices = { 
  me: () =>
    axios.get(`${API_URL}/client-portal/me`, { headers: authHeader() }),

  dashboard: (params) =>
    axios.get(`${API_URL}/client-portal/dashboard`, {
      params,
      headers: authHeader(),
    }),

  changePassword: (payload) =>
    axios.post(`${API_URL}/client-portal/change-password`, payload, {
      headers: authHeader(),
    }),

  logout: () =>
    axios.post(`${API_URL}/client-portal/logout`, {}, { headers: authHeader() }),
};

export default ClientPortalServices;
